var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage-style"},[(!_vm.isErro)?_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_vm._v("加载中，请稍后...")]):_c('van-empty',{attrs:{"image":"error","description":"加载失败，请联系管理员！"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }